import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import React, { memo, useCallback, useState } from 'react';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from 'shared/constants/microfrontends';
import { AdBannerMicrofrontendParallaxContainer } from 'shared/containers/AdBannerMicrofrontendParallaxContainer';
import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { AdfoxContextProviderProps } from '../../utils/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };
const P_PARAMS_NEWBUILDING: AdfoxContextProviderProps['pParams'] = { p1: 'dazap', p2: 'y' };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'bvkoa', p2: 'y' };

type ParallaxBannerProps = {
  isNewbuilding: boolean;
  position: number;
};

export const ParallaxBanner = memo<ParallaxBannerProps>(function ParallaxBanner(props) {
  const { isNewbuilding, position } = props;
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  const [isHidden, setIsHidden] = useState(false);
  const hide = useCallback(() => setIsHidden(true), []);

  if (manifest) {
    if (isHidden) {
      return null;
    }

    return (
      <AdBannerMicrofrontendParallaxContainer
        manifest={manifest}
        position={position}
        isNewbuilding={isNewbuilding}
        onStub={hide}
        onError={hide}
        onClose={hide}
      />
    );
  }

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="Баннер параллакс (adFox) десктоп"
      size={SIZE}
      pParams={isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
});
